<template>
  <div
    class="doctor-info row no-gutters justify-content-between align-items-start py-2"
  >
    <router-link
      :to="`/doctor/${doctor.id}`"
      class="row no-gutters align-items-center flex-nowrap col-12 col-lg-4 pr-2"
    >
      <div class="col-auto pl-2 pl-md-4">
        <div
          :style="{
            backgroundImage: `url(${staticUrl}${doctor.photo})`,
          }"
          class="avatar shadow d-inline-block"
          :class="{ doconline: doctor && isOnline(doctor.id) }"
        ></div>
      </div>
      <div class="col pl-3 mb-2">
        <small
          class="text-muted"
          v-if="doctor.speciality_id && specialityById(doctor.speciality_id)"
        >
          {{ specialityById(doctor.speciality_id).doctor_name[authLocale] }}
        </small>
        <h4 v-if="doctor && doctor.firstname">
          {{ doctor.firstname[authLocale] }}
          {{ doctor.lastname[authLocale] }}
        </h4>
        <small class="d-block text-muted" v-if="doctor.experience_from">
          <span v-if="doctor.title">{{ doctor.title[authLocale] }}</span>
          {{ $moment().format("YYYY") - doctor.experience_from }}
          {{ $t("experience") }}
        </small>
      </div>
    </router-link>
    <div class="col">
      <div class="row no-gutters mb-3">
        <router-link
          :to="`/doctor/${doctor.id}?service=${s.id}`"
          v-for="s of doctor.clinic_services"
          :key="s.id"
          class="col p-3 text-left shadow-sm shadow-hover m-2 service-item pointer text-primary"
          :class="{
                  'current shadow': serviceId === s.id
                }"
        >
          <div class="row no-gutters flex-nowrap mb-2">
            <div class="col pr-3">
              <div class="icon mb-2">
                <ServiceTypeIcon :type="s.type"></ServiceTypeIcon>
              </div>
              <small>{{ $t(s.type) }}</small>
            </div>
            <div class="col">
              <div class="h-100 d-flex flex-wrap">
                <h1 class="text-right mb-0 align-self-start w-100">₾</h1>
                <strong class="d-block w-100 text-right align-self-end">
                  {{ Math.round(s.price / 100).toFixed(2) }}
                </strong>
              </div>
            </div>
          </div>
          <!-- <small
            class="d-block mb-2 text-center"
            :class="{
                    'text-primary': service_id === s.id,
                    'text-muted': service_id !== s.id,
                  }">
            {{ s.name[authLocale] }}
            <span v-if="s.name_addition">
              ({{ s.name_addition[authLocale] }})
            </span>
          </small> -->
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ServiceTypeIcon from '@/components/ServiceTypeIcon'
export default {
  components: {
    ServiceTypeIcon
  },
  props: {
    doctor: {
      type: Object,
      required: true
    },
    serviceId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      isOnline: 'status/isOnline',
      authLocale: 'auth/locale',
      specialityById: 'speciality/byId'
    })
  }
}
</script>
<style lang="scss">
.doctor-info {
  .avatar {
    width: 75px;
    height: 75px;
    border-radius: 50px;
    &.doconline {
      border: 3px solid #28a745;
    }
  }
  .icon {
    svg {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "experience": "წლის გამოცდილება"
  },
  "en": {
      "telemedicine": "Online",
      "visit": "At Clinic",
      "house_call": "House Call",
      "experience": "Years of Experience"
  }
}
</i18n>
